module.exports = __webpack_public_path__ + "static/media/voting-guide.5a1ea32c.png";